import {Keys} from '../Form/consts/keys';
import {getConnection} from '../../_shared/GWTBridge/invoke/genPage';
import {getStateXml} from '../../_shared/GWTBridge/invoke/server';
import {buildServerCall} from '../../services/wcfService';

export function getFormHelpMessage(currentForm) {
    const methodName = 'FormKey';
    const reason = 'form help';

    const statexml = getStateXml(currentForm.session);
    const parameters = {
        statexml: [statexml],
        key: [(-Keys.FormHelp).toString()]
    };

    return buildServerCall(methodName, parameters, reason, false, getConnection, true);
}

export async function getEntityHelp(exec: string) {
    const statexml = getStateXml();
    const parameters = {statexml: [statexml], exec: [exec.toString()]};
    return await buildServerCall('FormExecHelp', parameters, 'Help', false, getConnection, true);
}
